import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "arrow-clockwise-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "currentColor", d: "M8 .75a.5.5 0 0 1 .83-.376l2 1.75a.5.5 0 0 1 0 .752l-2 1.75A.5.5 0 0 1 8 4.25V3.022a5.5 5.5 0 1 0 5.583 3.373.5.5 0 0 1 .924-.383A6.5 6.5 0 1 1 8 2.019Z" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
